import { Component, Vue } from 'vue-property-decorator'
import { UserModule } from '@/store/modules/user'
import { gettHeaderByType, settHeaderByType} from '@/api/common'
import { getFinanceArchiveList, getDepartmentByLevel, financeArchiveExportData } from '@/api/financial-center'
import { formatDate } from '@/utils/timeFilter'
import { menuBtn } from '@/utils/menu_level2_button'

const projectTypeFilter = [
    { key: '全部', value: 0 },
    { key: '国外小组科研', value: 1 },
    { key: '国内1对1', value: 2 },
    { key: '国外1对1', value: 3 },
    { key: '名校实验室', value: 4 },
    { key: 'AI HUB', value: 5 },
    { key: '全球华人导师', value: 6 },
    { key: '博雅计划-在线', value: 27 },
    { key: 'IEPQ线上项目', value: 30 },
    { key: '竞赛', value: 31 },
    { key: '全球华人导师-香港', value: 32 },
    {value: 38, key: '海外导师线下项目'},
    {value: 39, key: '国内导师线下项目'},
    {value: 40, key: '竞赛1v1'},
    {value: 42, key: 'IEPQ 1v1'},
    {value: 44, key: '全球华人导师-海外'},
    {value: 45, key: '企业导师远程实训'},
    {value: 47, key: '博雅计划-线下'},
    {value: 48, key: 'IEPQ 1v3'},
    {value: 49, key: '专业选修课'},
    {value: 50, key: 'IEPQ线下项目'},
    {value: 51, key: 'CERTIPORT认证课程'},
    {value: 52, key: '境外游学项目'},
    {value: 53, key: '竞赛线下（营地）'},
    {value: 54, key: '竞赛线下（研学）'},
]

@Component({})
export default class ArchiveList extends Vue {
    // data
    tableHeadPopoverShow = false
    tableHeader: { filds: string; cnFilds: string; isShow: boolean; id: number }[] = []
    tableHead: any[] = []
    tableData = []
    page = 1
    limit = 20
    total = 0
    tableHeadFilter = {
        parentMarketCooperationStr: '',  //上级合作伙伴
        project: '',  //项目 下拉搜索
        customer: '',  //客户  下拉搜索
        directorUserIdList: [], //负责人id  多选
        createdUserId: '', //订单创建人id  多选
        sourceType: '',  //来源  多选
        customerSource: '',  //具体来源
        invoiceMain: '',  //开票主体  下拉单选
        invoiceStatus: '', //开票状态  允许值: 0-审批中, 1-已通过, 2-未通过, 3-未提交, 4-已撤回
        startTime: '',  //  开课时间
        sessionTime: '',  //结课时间
        backCommissionTime: '',  //返佣通过时间
        orderCreationTime: '',  //订单创建时间
        amountCollected: '',  //待回款金额
        refundAmount: '',  //退款金额
        projectCost: '',  //项目成本
        level1DepartmentId: '', //一级部门id
        level2DepartmentId: '', //二级部门id
        level3DepartmentId: '', //三级部门id
        level4DepartmentId: '', //四级部门id
        classEndAt: [], // 捷克时间
        souCourseTypeId: '', //项目类型
        financeOrderCode: '', //订单编号
        // financeBackMoneyCreatedAt: [],  //回款创建时间
        doubleSouCourseName:'', // 双课题备注
        filter_status :'' // 订单审批状态
    }
    filter_discountPrice  = '' //订单金额
    filter_discount  = '' //订单金额
    tableCheckedData = []
    departmentList = []
    dialogShow = false
    receiverUser = '' // 修改后的负责人
    tableKey = Math.random()
    loading = false
    exportButtonDisabled = false
    projectTypeFilter = projectTypeFilter //项目类型
    timer = null
    vdaH = 0 //屏幕高度
    originHeight: any = '' //屏幕高度
    heightScroll = false
    popHeight = 0
    draggableList = []
    draggableListChange = []
    filter_price  = '' //订单金额
    filter_amount = '' //订单金额

    menuBtn = menuBtn
    // computed
    get userList() {
        return UserModule.userList
    }
    get startTime() {
        let str = ''
        if(!this.tableHeadFilter.startTime || this.tableHeadFilter.startTime.length === 0) {
            str = ''
        } else {
            str = formatDate('yyyy-MM-dd', new Date(this.tableHeadFilter.startTime[0])) + '/' + formatDate('yyyy-MM-dd', new Date(this.tableHeadFilter.startTime[1]))
        }
        return str
    }
    get sessionTime() {
        let str = ''
        if(!this.tableHeadFilter.sessionTime || this.tableHeadFilter.sessionTime.length === 0) {
            str = ''
        } else {
            str = formatDate('yyyy-MM-dd', new Date(this.tableHeadFilter.sessionTime[0])) + '/' + formatDate('yyyy-MM-dd', new Date(this.tableHeadFilter.sessionTime[1]))
        }
        return str
    }
    get backCommissionTime() {
        let str = ''
        if(!this.tableHeadFilter.backCommissionTime || this.tableHeadFilter.backCommissionTime.length === 0) {
            str = ''
        } else {
            str = formatDate('yyyy-MM-dd', new Date(this.tableHeadFilter.backCommissionTime[0])) + '/' + formatDate('yyyy-MM-dd', new Date(this.tableHeadFilter.backCommissionTime[1]))
        }
        return str
    }
    get orderCreationTime() {
        let str = ''
        if(!this.tableHeadFilter.orderCreationTime || this.tableHeadFilter.orderCreationTime.length === 0) {
            str = ''
        } else {
            str = formatDate('yyyy-MM-dd', new Date(this.tableHeadFilter.orderCreationTime[0])) + '/' + formatDate('yyyy-MM-dd', new Date(this.tableHeadFilter.orderCreationTime[1]))
        }
        return str
    }
    get classEndAt() {
        let str = ''
        if(this.tableHeadFilter.classEndAt && this.tableHeadFilter.classEndAt.length > 0) {
            str = formatDate('yyyy-MM-dd', new Date(this.tableHeadFilter.classEndAt[0])) + '/' + formatDate('yyyy-MM-dd', new Date(this.tableHeadFilter.classEndAt[1]))
        }
        return str
    }
    // get financeBackMoneyCreatedAt(){
    //     let str = ''
    //     if(this.tableHeadFilter.financeBackMoneyCreatedAt && this.tableHeadFilter.financeBackMoneyCreatedAt.length > 0) {
    //         str = formatDate('yyyy-MM-dd', new Date(this.tableHeadFilter.financeBackMoneyCreatedAt[0])) + '&' + formatDate('yyyy-MM-dd', new Date(this.tableHeadFilter.financeBackMoneyCreatedAt[1]))
    //     }
    //     return str
    // }
    /* created */
    created() {
        this.gettHeaderByType()
        const h = document.documentElement.clientHeight || document.body.clientHeight;
        this.vdaH = h - 260 ;
        this.popHeight = this.vdaH
    }
    updated(){
        // this.$nextTick(() => {
        //     let h = document.documentElement.clientHeight || document.body.clientHeight;
        //     this.vdaH = h - 260 + 'px' + '!important';
        //     this.originHeight = document.getElementById("idu").offsetHeight;
        //     console.log('h',  h)
        //     console.log('vdaH',  this.vdaH)
        //     console.log('originHeight', this.originHeight)
        //     if (this.originHeight > h) { //盒子超出屏幕高度
        //         this.heightScroll = true
        //     } else {
        //         this.heightScroll = false
        //     }
        // })
    }
    handleLevalPersonl(val) {
        this.getDepartmentByLevel(val)
    }
    // 等级人员列表
    async getDepartmentByLevel(level) {
        const data: any = await getDepartmentByLevel(level)
        this.departmentList = data.departmentList
    }
    // 列表
    async getTableData() {
        this.loading = true
        const price = this.filter_amount + this.filter_price
        const discountPrice = this.filter_discount + this.filter_discountPrice
        const obj = {
            limit: this.limit,  //条数/页
            page: this.page, //页码
            customerName: this.tableHeadFilter.customer,  //客户名称
            souCourseName: this.tableHeadFilter.project,  //项目名称
            sourceType: this.tableHeadFilter.sourceType,  //来源 允许值: '0-合作伙伴', '1-市场渠道', '2-其他'
            customerSource: this.tableHeadFilter.customerSource,  //具体来源
            parentMarketCooperationStr: this.tableHeadFilter.parentMarketCooperationStr,  //上级合作伙伴
            souCourseSchoolBegin: this.startTime,  //项目开课时间
            createdAt: this.orderCreationTime,  //订单创建时间
            classEndAt: this.classEndAt || '', // 结课时间
            directorUserIdList: this.tableHeadFilter.directorUserIdList, //负责人id
            createdUserId: this.tableHeadFilter.createdUserId, //订单创建人id
            level1DepartmentId: this.tableHeadFilter.level1DepartmentId, //一级部门
            level2DepartmentId: this.tableHeadFilter.level2DepartmentId, //一级部门
            level3DepartmentId: this.tableHeadFilter.level3DepartmentId, //一级部门
            level4DepartmentId: this.tableHeadFilter.level4DepartmentId, //一级部门
            souCourseTypeId: this.tableHeadFilter.souCourseTypeId, //一级部门
            doubleSouCourseName: this.tableHeadFilter.doubleSouCourseName, //一级部门
            financeOrderPrice: discountPrice,
            financeOrderCode: this.tableHeadFilter.financeOrderCode,  //订单编号
            // financeBackMoneyCreatedAt: this.financeBackMoneyCreatedAt,
            souCoursePrice: price, //订单金额
            status: this.tableHeadFilter.filter_status, //订单金额
        }
        if(this.filter_amount && !this.filter_price){
            delete obj.souCoursePrice
        }
        if(this.filter_discount && !this.filter_discountPrice){
            delete obj.financeOrderPrice
        }
        for(const key in obj) {
            if(obj[key].length == 0 || !obj[key]) {
                delete obj[key]
            }
        }
        const data: any = await getFinanceArchiveList(obj)
        this.tableData = data.financeArchiveList
        this.total = data.allNum
        this.tableKey = Math.random()
        this.$nextTick(() => {
            (this.$refs.multipleTable as HTMLFormElement).doLayout();
            (this.$refs.multipleTable as HTMLFormElement).bodyWrapper.scrollTop = 0;
        });
        this.loading = false

    }
    // 表头
    async gettHeaderByType() {
        const data: any = await gettHeaderByType(13)
        this.draggableList = data.headerUserList
        this.tableHead = JSON.parse(JSON.stringify(data.headerUserList))
        this.draggableListChange = JSON.parse(JSON.stringify(data.headerUserList))
        this.getTableData()
    }
    changeTable() {
        const newArr = []
        this.draggableListChange.forEach(item => {
            if (item.isShow === true) {
                newArr.push(item)
            }
        })
        if (newArr.length == 1) {
            newArr.forEach(item => {
                item.isDisBtn = true
            })
        } else {
            newArr.forEach(item => {
                item.isDisBtn = false
            })
        }
    }
    // 设置表头
    async draggableEnd() {
        this.tableHeadPopoverShow = false
        this.draggableList = this.draggableListChange
        const newArr: object = this.draggableList.filter(item =>
            item.isShow === true
        )
        if ((newArr as []).length > 0) {
            await settHeaderByType({types: 13, headerIds: this.draggableList})
            // this.tableKey = Math.random()
            this.$message.success('表头设置成功')
            this.gettHeaderByType()
        } else {
            this.$message.error('至少保留一个表头')
        }
    }
    doCancel(){
        this.draggableListChange = JSON.parse(JSON.stringify( this.draggableList))
        this.tableHeadPopoverShow = false
    }
    handle(){
        document.body.click()
    }
    pageChange(page: number) {
        // this.handle()
        // (this.$refs.popoverSH as HTMLFormElement).doClose()
        if (this.timer !== null) clearTimeout(this.timer)
        this.timer = setTimeout(() => {
            this.page = page
            this.getTableData()
        }, 1000)
    }
    pageSizeChange(limit: number) {
        this.limit = limit
        this.getTableData();
    }
    handleSelectionChange(row: any) {
        this.tableCheckedData = row
    }
    // 多选更换负责人
    async dialogConfirm() {
        if (!this.receiverUser) {
            this.$message.error('请选择负责人')
            return
        }
        (this.$refs['multipleTable'] as HTMLFormElement).clearSelection();
    }
    // 导出
    async exportExcel() {
        this.exportButtonDisabled = true
        const price = this.filter_amount + this.filter_price
        this.$message.success('数据已转入后台导出, 请前往下载列表查看')
        const discountPrice = this.filter_discount + this.filter_discountPrice
        const obj = {

            customerName: this.tableHeadFilter.customer,  //客户名称
            souCourseName: this.tableHeadFilter.project,  //项目名称
            sourceType: this.tableHeadFilter.sourceType,  //来源 允许值: '0-合作伙伴', '1-市场渠道', '2-其他'
            customerSource: this.tableHeadFilter.customerSource,  //具体来源
            parentMarketCooperationStr: this.tableHeadFilter.parentMarketCooperationStr,  //上级合作伙伴
            souCourseSchoolBegin: this.startTime,  //项目开课时间
            createdAt: this.orderCreationTime,  //订单创建时间
            classEndAt: this.classEndAt || '', // 结课时间
            directorUserIdList: this.tableHeadFilter.directorUserIdList, //负责人id
            createdUserId: this.tableHeadFilter.createdUserId, //订单创建人id
            level1DepartmentId: this.tableHeadFilter.level1DepartmentId, //一级部门
            level2DepartmentId: this.tableHeadFilter.level2DepartmentId, //一级部门
            level3DepartmentId: this.tableHeadFilter.level3DepartmentId, //一级部门
            level4DepartmentId: this.tableHeadFilter.level4DepartmentId, //一级部门
            souCourseTypeId: this.tableHeadFilter.souCourseTypeId, //一级部门
            doubleSouCourseName: this.tableHeadFilter.doubleSouCourseName, //一级部门
            financeOrderPrice: discountPrice,
            financeOrderCode: this.tableHeadFilter.financeOrderCode,  //订单编号
            souCoursePrice: price, //订单金额
            status: this.tableHeadFilter.filter_status, //订单金额
        }
        if(this.filter_amount && !this.filter_price){
            delete obj.souCoursePrice
        }
        if(this.filter_discount && !this.filter_discountPrice){
            delete obj.financeOrderPrice
        }
        for(const key in obj) {
            if(obj[key].length === 0 || !obj[key]) {
                delete obj[key]
            }
        }
        financeArchiveExportData(obj).finally(() => {
            this.exportButtonDisabled = false
        })
    }

    /*
    按钮权限验证
    */
    handleBtn(id: number) {
        return menuBtn(id)
    }
}
